import { useState } from 'react'
import { Collapse, Form, InputNumber, notification, Select } from 'antd'
import Cards from '../../../assets/images/hogar-vivienda.png'

// @styles 
import '../cards-coverages/styles.scss'
import './styles.scss'
import Context from 'context/appContext'
import { useContext } from 'react'
import { formatPrice, getBodyCalculator, getNotificationStyle, getPrice, setFieldsValue } from 'utils/utils'
import { useEffect } from 'react'
import LoadingProcedure from 'components/loading-procedure'
import ModalWarning from 'components/modal-warning'


export default function CardsCollapse({ cover, index, form }) {
    const [defaultClass, setDefaultClass] = useState('default');
    const [api, contextHolder] = notification.useNotification();
    const [loadingComponent, setLoadingComponent] = useState(false);
    const [alert, setAlert] = useState(false);
    const [months, setMonths] = useState(3);
    const additionals = ['TEV', 'FHM'];
    const regex = /\B(?=(\d{3})+(?!\d))/g;
    const messageAdd = "Tu cobertura ha sido agregada con éxito";
    const messageRemove = "Tu cobertura ha sido removida con éxito";

    const { dataForm: { data, formResponses }, customRequest, setDataForm, formStatus: { steps, currentStep, currentQuestion },
        setPriceToShow, setSidebarData, additionalCoverages, setAdditionalCoverages, sidebarData, setReturnButton, setDisabledButtonContinue, activeKey, priceToShow, setActiveKey, currency, setCurrency, isActiveAditionals } = useContext(Context);

    useEffect(() => {
        getDefaultValueSelect();
    }, [])

    useEffect(() => { !priceToShow && additionalCoverages && additionalCoverages.length > 0 && sidebarData && serviceCalculator(null, activeKey); getSidebarData(); }, [additionalCoverages]);

    const getDefaultValueSelect = () => {
        const item = formResponses.find((x) => x.key === 'months');
        const value = item && item.value ? item.value : 3;
        handleChange(value, false);
    }


    const handleChange = (value, calculator) => {
        const indexPerdida = formResponses.findIndex(x => x.code === '1143');
        if (indexPerdida !== -1) {
            formResponses[indexPerdida]['months'] = value;
            setFieldsValue('months', value, null, formResponses, form);
            setMonths(value);
        }
        calculator && serviceCalculator();
    };

    useEffect(() => {
        getSidebarData();
    }, [activeKey])

    const getSublimitOrValue = (coverage) => {
        let sum = 0
        const index = coverage && coverage.index >= 0 && Number(coverage.index);
        const currencyLimit = coverage && coverage.currencyLimit && coverage.currencyLimit[index || 0];
        currencyLimit && currencyLimit.insuredSumCriteria && currencyLimit.insuredSumCriteria.dependencies
            && currencyLimit.insuredSumCriteria.dependencies.forEach((key) => {
                const valueCovDependency = Number(form.getFieldValue(key));
                sum = sum + (valueCovDependency >= 0 ? getPrice(Number(valueCovDependency)) : 0);
            })
        const formula = currencyLimit && currencyLimit.insuredSumCriteria && currencyLimit.insuredSumCriteria.formula && currencyLimit.insuredSumCriteria.formula.replace(/[SUM({dependencias})]{19}|[EQ({dependencias})]{18}/g, sum);
        const subLimit = formula && eval(formula);
        let valueField = getPrice(Math.floor(subLimit));
        // if (coverage && coverage.code && !coverage.input && getPrice(Math.floor(subLimit)) > 0) {
        //     valueField = coverage && coverage.typeCoverage && additionals.includes(coverage.typeCoverage) ? isActiveAditionals[coverage.typeCoverage] ? valueField : 0 : valueField;
        //     const indexField = coverage && formResponses.findIndex(x => x.code === coverage.code);
        //     coverage['value'] = valueField
        //     indexField !== -1 ? formResponses[indexField]['value'] = valueField : formResponses.push(coverage)
        // }
        return valueField
    }

    const onActiveClassCard = async (key, mandatory, coverageInput, defaultValue) => {

        let value = defaultValue
        const codeCoverage = coverageInput && coverageInput.code;
        const select = activeKey && activeKey[codeCoverage];
        const index = formResponses.findIndex(x => x.code === codeCoverage);
        coverageInput['value'] = value;
        index !== -1 ? formResponses[index].value = value : formResponses.push(coverageInput);
        form.setFieldsValue({ [codeCoverage]: Math.floor(value) });
        
        if (!mandatory) {
            const keyActiveK = 'activeKeys';
            const copyActiveKey = JSON.parse(JSON.stringify(activeKey));
            select && setFieldsValue(key, 0, coverageInput, formResponses, form);
            // console.log(codeCoverage,select, value, coverageInput);
            // !select && setFieldsValue(codeCoverage, value , coverageInput, formResponses, form);
            setActiveKey({ ...activeKey, [key]: !select });
            const indexActiveKey = formResponses.findIndex(x => x.code === keyActiveK);
            indexActiveKey !== -1 ? formResponses[indexActiveKey].value = { ...copyActiveKey, [key]: !select } : formResponses.push({ code: keyActiveK, value: { ...copyActiveKey, [key]: !select } });
        }
        codeCoverage === '1143' && select && setMonths('3');
        await serviceCalculator(!select && coverageInput);
        openNotification(!select);
        getSidebarData();
    }

    const openNotification = (choosed, messageChange) => {
        getSidebarData();

        if (choosed) {
            openNotificationWithIcon("success", messageChange || messageAdd);
        } else {
            openNotificationWithIcon("error", messageRemove);
        }
    };

    const openNotificationWithIcon = (type, description) => {
        api[type]({
            message: ``,
            description,
            style: getNotificationStyle(type),
        });
    };

    const serviceCalculator = async (coverageInput, activeKey) => {
        setLoadingComponent(true);
        const valPrimary = steps[currentStep] && steps[currentStep].questions[currentQuestion] && steps[currentStep].questions[currentQuestion].primary;
        const options = valPrimary && valPrimary.opciones_servicio_segundo_plano
            ? valPrimary.opciones_servicio_segundo_plano
            : '';
        const opciones_servicio = options && JSON.parse(options);
        const body = getBodyCalculator(opciones_servicio.body, formResponses, form, coverageInput, activeKey);
        await customRequest(opciones_servicio.url, opciones_servicio.header, opciones_servicio.method, body).then((res) => {
            if (res && res.errors) {
                const errors = res && res.errors
                setAlert({ active: true, message: errors.description, fields: errors.fields })
            }
            res && res.data && res.data.totalPremium && setPriceToShow(res.data.totalPremium);
            return false
        })
        setLoadingComponent(false);
    }

    const getMaxValue = (limitCalculated, limitCurrency, coverage) => {
        let maxValue = limitCurrency && ((limitCalculated && limitCalculated < limitCurrency.min) ? limitCurrency.min : (limitCalculated > limitCurrency.max) ? limitCurrency.max : limitCalculated);
        if (coverage && coverage.code === '1143' && maxValue) {
            const field = formResponses.find(x => x.code === '1143');
            const numeroMeses = field && field.months || 3;
            maxValue = maxValue / numeroMeses
        }
        return Math.trunc(maxValue);
    }

    const getMinValue = (limitCurrency, coverage) => {
        let min = limitCurrency.min ? limitCurrency.min : limitCurrency.max ;
        if (coverage && coverage.code === '1143') {
            const field = formResponses.find(x => x.code === '1143');
            const numeroMeses = field && field.months || 3;
            min = min / numeroMeses;
        }
        return Math.trunc(min);
    }

    const getCoverages = (coverages, filter) => {
        let coveragesRender = [];
        const render = coverages && coverages.map(coverage => {
            const indexField = formResponses.findIndex(x => x.code === coverage.code);
            indexField === -1 && formResponses.push(coverage);
            const coverageInput = coverage && coverage.input;
            const limits = coverage && coverage.currencyLimit[0]; // limits *
            const mandatory = coverage && coverage.mandatory;
            const limitCurrency = currency ? limits && limits.mxn : limits && limits.usd;
            const defaultValue = coverage && getMinValue(limitCurrency, coverage);
            const codeCoverage = coverage && coverage.code;
            const limitCalculated = getSublimitOrValue(coverage);
            coverage && coverage.code && !mandatory && !activeKey[codeCoverage] && setFieldsValue(coverage.code, 0, coverage, formResponses, form)
            const maxValue = getMaxValue(limitCalculated, limitCurrency, coverage);
            coverage['maxValue'] = maxValue;
            const render = (coverage && coverage.input && maxValue || (!coverageInput && (limits && limits.insuredSumCriteria ? limitCalculated : coverage.insuredSumDefault)));
            render && coveragesRender.push(coverage.code);
            return !filter && render ? (
                <div className="coverages-collapse additional-card">
                    <div className="coverages-collapse__content">
                        <div className="coverages-collapse__content-additionalcards">
                            <div
                                className={`coverages-collapse__content-additionalcards__item ${(mandatory ? true : activeKey[codeCoverage]) ? "active-card" : ""}`}
                                key={index}
                                onClick={''}
                            >
                                <img
                                    className="coverages-collapse__content-additionalcards__item-img"
                                    src={coverage && coverage.render && coverage.render.img ? coverage.render.img : Cards}
                                    alt={coverage?.render?.title}
                                />
                                <div className="coverages-collapse__content-additionalcards__item-text">
                                    <strong>{coverage.render.title}</strong>
                                    <p>{coverage.render.body}</p>
                                </div>
                                <div className="coverages-collapse__content-additionalcards__item-actions">
                                    <div className="coverages-collapse__content-additionalcards__item-actions-btns">
                                        <div className='smallswitch__container' id={cover}>
                                            <div className='smallswitch__container__buttons' id={cover}>
                                                <button className={`smallswitch__container__buttons-btn ${!(mandatory ? true : activeKey[codeCoverage]) && defaultClass}`}
                                                    disabled={!(mandatory ? true : activeKey[codeCoverage])}
                                                    onClick={() => !mandatory && codeCoverage!=="4523" && onActiveClassCard(codeCoverage, mandatory, coverage, defaultValue)}>
                                                    <span>No</span>
                                                </button>
                                                <button className={`smallswitch__container__buttons-btn ${(mandatory ? true : activeKey[codeCoverage]) ? 'active-btn-right' : ''}`}
                                                    disabled={(mandatory ? true : activeKey[codeCoverage])}
                                                    onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverage, defaultValue)}>
                                                    <span>Si</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="coverages-collapse__content-additionalcards__item-price">
                                        <p className={`coverages-collapse__content-additionalcards__item-price-value ${codeCoverage === '1143' && (form.getFieldValue('1143') > maxValue || form.getFieldValue('1143') < getMinValue(limitCurrency, coverage)) && 'error'}`}>
                                            <Form.Item>
                                                <Form.Item name={codeCoverage}
                                                    rules={[
                                                        {
                                                            pattern: new RegExp(codeCoverage === '1143' && activeKey[codeCoverage] && ((form.getFieldValue('1143') > maxValue || form.getFieldValue('1143') < getMinValue(limitCurrency, coverage))) ? 'error' : ''),
                                                            message: ''
                                                        }
                                                    ]}
                                                >
                                                    {<InputNumber
                                                        id={codeCoverage}
                                                        min={getMinValue(limitCurrency, coverage)}
                                                        disabled={!coverageInput}
                                                        max={limits && !limits.insuredSumCriteria ? limitCurrency.max : maxValue || limitCurrency.max}
                                                        maxLength={21}
                                                        formatter={value => `${value}`.replace(/[^0-9]/g, '').replace(regex, ',')}
                                                        defaultValue={getDefaultValue(coverage, defaultValue, limitCurrency, maxValue)}
                                                        onBlur={(e) => {
                                                            onBlur(e, coverage, limits && !limits.insuredSumCriteria ? limitCurrency.max : maxValue, limitCurrency)
                                                        }}
                                                        autoComplete="off"
                                                        required={mandatory}
                                                        data-testid="numberInput"
                                                    />}
                                                    {/* />  coverage && coverage.insuredSumDefault && formatPrice(coverage.insuredSumDefault)} */}
                                                </Form.Item>
                                                <span className="suffix">{currency ? 'MXN' : 'USD'}</span>
                                            </Form.Item>
                                        </p>
                                        {codeCoverage === '1143' && ((form.getFieldValue('1143') > maxValue) && <div className="ant-text-description">Máximo 5% de la suma asegurada de Vivienda</div>)}
                                        <div className="coverages-collapse__content-additionalcards__item-price-description">
                                            <strong>SUMA ASEGURADA</strong>
                                        </div>
                                        {coverageInput && <div className='coverages-collapse__content-additionalcards__item-price-description-range'>
                                            <p>MÍNIMO: {formatPrice(getMinValue(limitCurrency, coverage))}</p>
                                            <p>MÁXIMO: {formatPrice(maxValue)}</p>
                                        </div>}
                                        <div className='coverages-collapse__content-additionalcards__item-price-description-select'>
                                            {coverage && coverage.code === '1143' && <Form.Item>
                                                <Select
                                                    onChange={(e) => handleChange(e, true)}
                                                    id={'months'}
                                                    name={'months'}
                                                    defaultValue={months || '3'}
                                                    dropdownStyle={{ borderRadius: 0, border: '1px solid rgba(0, 0, 0, 0.2)', boxShadow: 'none' }}
                                                >
                                                    <Select.Option value="3">3 meses</Select.Option>
                                                    <Select.Option value="4">4 meses</Select.Option>
                                                    <Select.Option value="5">5 meses</Select.Option>
                                                    <Select.Option value="6">6 meses</Select.Option>
                                                    <Select.Option value="7">7 meses</Select.Option>
                                                    <Select.Option value="8">8 meses</Select.Option>
                                                    <Select.Option value="9">9 meses</Select.Option>
                                                    <Select.Option value="10">10 meses</Select.Option>
                                                    <Select.Option value="11">11 meses</Select.Option>
                                                    <Select.Option value="12">12 meses</Select.Option>
                                                </Select>
                                            </Form.Item>}
                                        </div>
                                    </div>
                                </div>
                                <div className='active-card__plus' onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverage, defaultValue)} />
                            </div>
                        </div>
                    </div>
                </div>
            ) : '';
        })
        return filter ? coveragesRender : render;
    }

    const getDefaultValue = (coverage, defaultValue, limitCurrency, maxValue) => {
        const code = coverage && coverage.code;
        const index = formResponses.findIndex(x => x.code === code);
        let value = form.getFieldValue(code);
        const isMandatory = coverage.mandatory;
        const isInput = coverage && coverage.input;
        const defaultV = !isInput ? maxValue || getSublimitOrValue(coverage) || limitCurrency.max : defaultValue;
        if (value === 0 && activeKey[code] || (activeKey[code] && value === undefined)) {
            setFieldsValue(code, defaultV, coverage, formResponses, form);
            index === -1 && formResponses.push(coverage);
        } else if (!isInput && activeKey[code]) {
            setFieldsValue(code, defaultV, coverage, formResponses, form);
        } else if (!isInput && !activeKey[code]) {
            setFieldsValue(code, 0, coverage, formResponses, form);
        }
    }

    const onBlur = (e, coverageInput, max, limitCurrency) => {
        let value = Number(getPrice(e && e.target && e.target.value));
        const minValue = getMinValue(limitCurrency, coverageInput);
        // const minValue = limitCurrency && limitCurrency.min;
        const maxvalue = max;
        const codeCoverage = coverageInput && coverageInput.code;
        const index = formResponses.findIndex(x => x.code === coverageInput.code);
        if (value === 0) {
            onActiveClassCard(codeCoverage, coverageInput.mandatory, coverageInput, coverageInput.defaultValue);
        } else {
            value = value >= maxvalue ? maxvalue : value <= minValue ? minValue : value;
            coverageInput['value'] = value;
            index !== -1 ? formResponses[index].value = value : formResponses.push(coverageInput);
            form.setFieldsValue({ [codeCoverage]: Math.floor(value) });
        }
        getSidebarData();
        serviceCalculator();
    }

    String.prototype.toProperCase = function () {
        return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();;
    };

    const getSidebarData = () => {
        let dataCopy = JSON.parse(JSON.stringify(sidebarData))
        let rowsOptionals = [];
        const totalCovOptionals = formResponses.filter(cov => cov && cov.code && cov.value);
        totalCovOptionals && totalCovOptionals.forEach(coverage => {
            const limits = coverage && coverage.currencyLimit && coverage.currencyLimit[0]; // limits **
            const valueCapturado = form.getFieldValue(coverage.code);
            coverage && (coverage.input || coverage.typeCoverage === 'OPC') && !coverage.mandatory && valueCapturado && (limits && limits.insuredSumCriteria !== null || coverage.typeCoverage === 'OPC') && rowsOptionals.push({
                label: coverage.description,
                value: formatPrice((valueCapturado))
            })

        });

        dataCopy[0].items[1] =
        {
            title: 'Opcionales Seleccionadas',
            values: [{
                rows: rowsOptionals
            }]
        }

        // dataCopy[0]['key'] = 'sidebarData'
        // const indexData = formResponses.findIndex(x => x.key === 'sidebarData');
        // indexData !== -1 ? formResponses[indexData] = dataCopy : formResponses.push(dataCopy);
        setSidebarData(dataCopy);
        return [sidebarData];
    }

    const getSubSections = () => {
        return additionalCoverages && additionalCoverages.map((subSection, i) => {
            const renderSubSection = getCoverages(subSection.coverages, 'filter');
            return renderSubSection && renderSubSection.length > 0 && (
                <Collapse.Panel
                    header={<div className='ant-collapse-header-description'><span>{subSection.title.toProperCase()}</span></div>}
                    key={i}
                >
                    {getCoverages(subSection.coverages)}

                </Collapse.Panel>
            )
        })
    }


    return (
        <>
            {loadingComponent && (<LoadingProcedure message={'Cotizando'} />)}
            {contextHolder}
            {alert && alert.active && <ModalWarning info={{ visible: true, type: 'error', message: alert && alert.message, fields: alert.fields }} callBack={() => setAlert({ active: false })} />}
            <div className='collapse__cards-container'>
                <Collapse
                    className='ant-collapse-cards'
                    accordion
                >
                    <>
                        {getSubSections()}
                    </>
                </Collapse>
            </div>
        </>
    )
}